import moment from "moment";
import { openOrdera } from "@/utils/menuUtils";
import menuService from "@/services/menu";
import companyService from "@/services/company";
import orderService from "@/services/order";

const state = () => ({
  menus: [],
  menu: null,
  loading: false,
  dialogs: {
    userLocation: false,
    newRestaurant: false,
    foodPreview: false,
    orderDetails: false,
  },
  selectedMeal: null,
  selectedItem: null,
  selectedDate: {
    name: "rucak",
    date: moment().format("YYYY-MM-DD"),
    shift: {
      text: "1-smena",
      key: "shift_one",
      value: 1,
    },
  },
  currentMenuDate: moment().format("YYYY-MM-DD"),
  userLocation: "",
  companies: [],
  allUserLocations: [],
  newUserLocation: {
    address: "",
    latitude: "",
    longitude: "",
  },
  partners: [],
  minOrderDate: moment().add(1, "days").format("YYYY-MM-DD"),
  orderTimes: {
    monday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    tuesday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    wednesday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    thursday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    friday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    saturday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
    sunday: {
      time: {
        time_hour: 0,
        time_minut: 0,
      },
      day_before_limit: 0,
      day_after_limit: 0,
    },
  },
});

const mutations = {
  SET_MENUS(state, menus) {
    const parseShiftMeals = (meals, shift, shiftCode) => {
      return (meals || [])
        .filter((meal) => {
          return meal[shiftCode] && menus.shifts[shiftCode];
        })
        .map((meal) => {
          return {
            ...meal,
            order: meal.orders.find((order) => {
              return order.shift === `${shift}-smena`;
            }),
          };
        });
    };
    state.menu =
      (menus.data || [])
        .filter((menu) => {
          if (menus.ignoreTimelimit) return true;

          return new Date(menu.date) >= new Date(state.minOrderDate);
        })
        .map((menu) => {
          return {
            ...menu,
            shifts: [
              {
                text: "1-smena",
                key: "one",
                value: 1,
                meals: parseShiftMeals(menu.meals, 1, "shift_one"),
                code: "shift_1",
              },
              {
                text: "2-smena",
                key: "two",
                value: 2,
                meals: parseShiftMeals(menu.meals, 2, "shift_two"),
                code: "shift_2",
              },
              {
                text: "3-smena",
                key: "three",
                value: 3,
                meals: parseShiftMeals(menu.meals, 3, "shift_three"),
                code: "shift_3",
              },
              {
                text: "4-smena",
                key: "four",
                value: 4,
                meals: parseShiftMeals(menu.meals, 4, "shift_four"),
                code: "shift_4",
              },
            ],
            orders: (menu.meals || [])
              .map((meal) => meal.orders)
              .flat()
              .map((order) => {
                return {
                  ...order,
                  meal: menu.meals.find((m) => m.id === order.meal_id),
                };
              }),
          };
        })[0] || null;
  },
  SET_ORDER(state, order) {
    const shiftIndex = state.menu.shifts.findIndex(
      (shift) => shift.text === order.shift
    );
    const mealIndex = state.menu.shifts[shiftIndex].meals.findIndex(
      (meal) => meal.id === order.meal_id
    );
    const meal = state.menu.shifts[shiftIndex].meals[mealIndex];
    if (meal?.order) {
      meal.order.quantity = order.quantity;
    }
  },
  ADD_ORDER(state, order) {
    const shiftIndex = state.menu.shifts.findIndex(
      (shift) => shift.text === order.shift
    );
    const mealIndex = state.menu.shifts[shiftIndex].meals.findIndex(
      (meal) => meal.id === order.meal_id
    );
    const meal = state.menu.shifts[shiftIndex].meals[mealIndex];
    if (meal) {
      meal.order = order;
    }
  },
  REMOVE_ORDER(state, order) {
    const shiftIndex = state.menu.shifts.findIndex(
      (shift) => shift.text === order.shift
    );
    const mealIndex = state.menu.shifts[shiftIndex].meals.findIndex(
      (meal) => meal.id === order.meal_id
    );
    const meal = state.menu.shifts[shiftIndex].meals[mealIndex];
    if (meal?.order) {
      meal.order = null;
    }
  },
  SET_DIALOG(state, { dialog, value }) {
    state.dialogs[dialog] = value;
  },
  SET_SELECTED_MEAL(state, meal) {
    state.selectedMeal = meal;
  },
  SET_SELECTED_ITEM(state, item) {
    state.selectedItem = item;
  },
  SET_SELECTED_DATE(state, date) {
    state.selectedDate = date;
  },
  SET_CURRENT_MENU_DATE(state, date) {
    state.currentMenuDate = date;
  },
  SET_USER_LOCATION(state, location) {
    state.userLocation = location;
  },
  SET_ALL_USER_LOCATIONS(state, locations) {
    state.allUserLocations = locations;
  },
  SET_NEW_USER_LOCATION(state, location) {
    state.newUserLocation = location;
  },
  SET_RESTAURANT(state, restaurant) {
    state.restaurant = restaurant;
  },
  SET_COMPANY(state, company) {
    state.company = company;
  },
  SET_PARTNERS(state, partners) {
    state.partners = partners;
  },
  SET_ORDER_TIMES(state, orderTimes) {
    state.orderTimes = orderTimes;
    const dayName = new Date()
      .toLocaleDateString("en-US", {
        weekday: "long",
      })
      .toLowerCase();

    const todayRules = state.orderTimes[dayName];
    if (!todayRules) return true;
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const day = now.getDate();

    const customHours = todayRules.time.time_hour;
    const customMinutes = todayRules.time.time_minut;

    const customDate = new Date(
      year,
      month,
      day,
      customHours,
      customMinutes,
      0,
      0
    );
    const isExpired = now.getTime() - customDate.getTime() > 0;
    const daysToAdd = isExpired
      ? todayRules.day_after_limit
      : todayRules.day_before_limit;
    let nextMenuDateObj = new Date(
      now.getTime() + daysToAdd * 24 * 60 * 60 * 1000
    );
    state.minOrderDate = nextMenuDateObj.toISOString().slice(0, 10);
  },
  SET_COMPANIES(state, companies) {
    state.companies = companies.map((company) => {
      return {
        id: company[0],
        name: company[1],
      };
    });
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
};

const actions = {
  async fetchCompanies({ commit, rootState, state }, companyId) {
    if (state.companies.length > 0) {
      return Promise.resolve(state.companies);
    }
    const { data } = await companyService.getCompanyList(companyId);
    commit("SET_COMPANIES", data);
  },
  async fetchMenus({ commit, state, rootState }, date = state.minOrderDate) {
    commit("SET_LOADING", true);
    commit("SET_CURRENT_MENU_DATE", date);
    try {
      const params = {
        from: date,
        to: date,
        type: "rucak",
      };
      const { data } = await menuService.getWebAppMenu(params);
      const { shift_one, shift_two, shift_three, shift_four } =
        rootState.company;
      const shifts = {
        shift_one,
        shift_two,
        shift_three,
        shift_four,
      };
      if (!data.length) {
        commit("SET_MENUS", {
          data: [],
          shifts,
          ignoreTimelimit: rootState.user.orderRules.ignoreTimelimit,
        });
        return;
      }
      // Process menus as needed (add shift info, etc.)
      commit("SET_MENUS", {
        data,
        shifts,
        ignoreTimelimit: rootState.user.orderRules.ignoreTimelimit,
      });
    } catch (e) {
      console.error("Error fetching menus:", e);
      commit("SET_MENUS", {
        data: [],
        shifts: {
          shift_one: false,
          shift_two: false,
          shift_three: false,
          shift_four: false,
        },
        ignoreTimelimit: rootState.user.orderRules.ignoreTimelimit,
      });
    } finally {
      commit("SET_LOADING", false);
    }
  },
  updateAllUserLocations({ commit }, locations) {
    commit("SET_ALL_USER_LOCATIONS", locations);
  },
  updateNewUserLocation({ commit }, location) {
    commit("SET_NEW_USER_LOCATION", location);
  },
  openOrdera(_, res) {
    openOrdera(res);
  },
  async orderAction({ commit, state }, payload) {
    try {
      // You may want to set a loading state here
      if (payload.quantity === 0) {
        try {
          await orderService.deleteOrder(payload.order.id);
          commit("REMOVE_ORDER", payload);
          return Promise.resolve(true);
        } catch (error) {
          return Promise.reject(error);
        }
      } else if (payload.order?.id) {
        try {
          const { data } = await orderService.updateOrder(
            payload.order.id,
            payload
          );
          commit("SET_ORDER", data.data);
          return Promise.resolve(data.data);
        } catch (error) {
          return Promise.reject(error);
        }
      } else {
        try {
          const { data } = await orderService.createOrder(payload);
          commit("ADD_ORDER", data.data);
          return Promise.resolve(data.data);
        } catch (error) {
          return Promise.reject(error);
        }
      }
    } catch (error) {
      // Handle error, show snackbar, etc.
    }
  },
  // Add more actions for reservation, dialog open/close, etc.
};

const getters = {
  // Add any needed getters for computed dialog state, selected meal/item, etc.
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
